import { useState } from "react";
import { TabPane } from "reactstrap";
import { LI, UL } from "../../../../AbstractElements";
import { useNavigate } from "react-router-dom";
import { SMSData } from "../types/types";
import SentSMSContent from "./SentSMSContent";
import SMSDetail from "./SMSDetail";
import CommunicationPagination from "../../CommunicationPagination";

interface SentContentProps {
  smsMessages: SMSData[];
  searchWord: string;
}

const SentContent: React.FC<SentContentProps> = ({
  smsMessages,
  searchWord,
}) => {
  const navigate = useNavigate();
  const [selectedSMS, setSelectedSMS] = useState<SMSData | null>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(10);

  const filteredSMS = smsMessages.filter(
    (sms) =>
      sms.recipientRoles.some((role) =>
        role.toLowerCase().includes(searchWord.toLowerCase())
      ) ||
      sms.message.toLowerCase().includes(searchWord.toLowerCase()) ||
      sms.description?.toLowerCase().includes(searchWord.toLowerCase())
  );

  const paginatedSMS = filteredSMS.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  const handleSMSClick = (sms: SMSData) => {
    navigate(`${process.env.PUBLIC_URL}/communication/sms-details`, {
      state: { sms },
    });
  };

  const handleBack = () => {
    setSelectedSMS(null);
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  return (
    <TabPane tabId="2">
      {selectedSMS ? (
        <SMSDetail sms={selectedSMS} onBack={handleBack} />
      ) : (
        <>
          <div className="mail-body-wrapper">
            <UL className="simple-list">
              {paginatedSMS.map((sms, i) => (
                <LI
                  className="inbox-data"
                  key={i}
                  onClick={() => handleSMSClick(sms)}
                  style={{ cursor: "pointer" }}
                >
                  <SentSMSContent data={sms} i={i} />
                </LI>
              ))}
            </UL>
          </div>
          <CommunicationPagination
            currentPage={currentPage}
            pageSize={pageSize}
            totalItems={filteredSMS.length}
            onPageChange={handlePageChange}
          />
        </>
      )}
    </TabPane>
  );
};

export default SentContent;
